import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import GallerySectionStyle2 from '../Section/GallerySection/GallerySectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
const galleryData = [
  { imgUrl: '/images/about/portfolio_4_lg.jpg' },
  { imgUrl: '/images/about/portfolio_5_lg.jpg' },
  { imgUrl: '/images/about/portfolio_2_lg.jpg' },
  { imgUrl: '/images/about/portfolio_3_lg.jpg' },
  { imgUrl: '/images/about/portfolio_5_lg.jpg' },
  { imgUrl: '/images/about/portfolio_5_lg.jpg' },
  { imgUrl: '/images/about/portfolio_4_lg.jpg' },
];

export default function Gallery() {
  pageTitle('Gallery');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Welcome to <br>Precision Ortho CAD Gallery"
        subTitle=""
      />
      <Section
        topMd={170}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <GallerySectionStyle2 data={galleryData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
                  bgUrl="images/about/footerbanner.png"
                  title="Don’t Let Your Smile <br />Take a Backseat!"
                  subTitle="Schedule a case with our experienced dental <br /> professionals today!"
                  center
                />
                
      </Section>
    </>
  );
}
